import { render, staticRenderFns } from "./MoveClassesPanel.vue?vue&type=template&id=9fa7839c&scoped=true&"
import script from "./MoveClassesPanel.vue?vue&type=script&lang=js&"
export * from "./MoveClassesPanel.vue?vue&type=script&lang=js&"
import style0 from "./MoveClassesPanel.vue?vue&type=style&index=0&id=9fa7839c&prod&lang=scss&scoped=true&"
import style1 from "./MoveClassesPanel.vue?vue&type=style&index=1&id=9fa7839c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa7839c",
  null
  
)

export default component.exports